export interface Benefit {
  emoji: string
  title: string
  description: string
}

export const benefits: Benefit[] = [
  {
    emoji: '✅',
    title: 'Tutto pronto da stampare',
    description:
      'Niente ricerca infinita di mappe mute o schede sparse: apri, scegli l’attività e stampi.',
  },
  {
    emoji: '🎯',
    title: 'Progressioni pensate per l’età reale',
    description:
      'Attività graduate e strutturate: non idee generiche, ma lavori calibrati sullo sviluppo e le capacità della classe.',
  },
  {
    emoji: '🧭',
    title: 'Orientamento, territorio e mappe, passo dopo passo',
    description:
      'Dall’orientamento di base alla geografia politica: impari e insegni a leggere lo spazio, il territorio e i dati geografici con metodo.',
  },
  {
    emoji: '🌍',
    title: 'Dall’Italia al mondo, in un unico percorso integrato',
    description:
      'Ogni volume collega il territorio vicino a quello più lontano: più senso, più coinvolgimento, meno lezioni scollegate.',
  },
]
